type SpriteTimeline = {
    artboardFrameCount: number
    fps: number
    spriteDuration: number
    spriteFrameCount: number
}

const minLoopCount = 1

const isPositiveFinite = (value: number) => Number.isFinite(value) && value > 0

// Use real duration when available so a longer layer does not stretch shorter sprites across the whole artboard.
export function getSpriteLoopCount({
    artboardFrameCount,
    fps,
    spriteDuration,
    spriteFrameCount,
}: SpriteTimeline): number {
    if (isPositiveFinite(artboardFrameCount) && isPositiveFinite(fps) && isPositiveFinite(spriteDuration)) {
        return Math.max(minLoopCount, artboardFrameCount / fps / spriteDuration)
    }

    if (isPositiveFinite(artboardFrameCount) && isPositiveFinite(spriteFrameCount)) {
        return Math.max(minLoopCount, Math.floor(artboardFrameCount / spriteFrameCount))
    }

    return minLoopCount
}

export function getSpriteTimelineProgress(
    artboardProgress: number,
    timeline: SpriteTimeline,
    reversed: boolean = false
): number {
    const loops = getSpriteLoopCount(timeline)
    const progress = (artboardProgress * loops) % 1

    return reversed ? 1 - progress : progress
}
